import { AchievementDefinition } from '../services/GameAPI';

export const TUNE_TESTERS_ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: "tune-testers-first-correct",
    gameId: "tune-testers",
    title: "Tune Detective",
    description: "Correctly identified your first sound in Tune Testers!",
    iconUrl: "🕵️",
    museCashReward: 25,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 1,
    category: "progression"
  },
  {
    id: "tune-testers-score-10",
    gameId: "tune-testers",
    title: "Sharp Ears",
    description: "Reached a score of 10 in Tune Testers.",
    iconUrl: "🎧",
    museCashReward: 75,
    type: "progression",
    rarity: "rare",
    implemented: true,
    sortOrder: 2,
    category: "progression"
  },
  {
    id: "tune-testers-perfect-streak-5",
    gameId: "tune-testers",
    title: "Unbroken Rhythm",
    description: "Got 5 answers right in a row!",
    iconUrl: "🔥",
    museCashReward: 100,
    type: "skill",
    rarity: "rare",
    implemented: true,
    sortOrder: 3,
    category: "skill"
  }
]; 